import React, { useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import { Colors } from "src/assets/colors/Colors";
import InputForm from "src/components/ComponentesFormularios/InputForm";
import { GlobalConstants } from "src/data/GlobalConstants";
import { modalCRUDService } from "src/services/modalCRUDService";
import ImagePickerCrop from "src/components/ImagePickerCrop";
import { marcasService } from "src/services/unoauno/apiMarcas";
import { getCurrentTime, toBlob } from "src/util/functions";

const FormCRUDMarcas = ({ properties }) => {
    const { data: { 
        proveedor,
        edit, 
        reload,
        marca
    }} = properties;

    const dispatch = useDispatch();

    const [urlImagen, setUrlImagen] = useState(edit ? marca?.urlImagen ?? "" : "");
    const previewRef = useRef(null);

    const methods = useForm({defaultValues: {
        nombreMarca: edit ? marca?.nombre : "",
        orden: edit ? marca?.orden : ""
    }});

    const { control, handleSubmit, formState: { errors } } = methods;

    const onClickGuardar = async (datos) => {
        let idMarca = marca?.idMarca;
        datos.orden ||= "0";
        
        try {
            if(edit) {
                await marcasService.updateMarca({ ...datos, idMarca: marca?.idMarca });
            }else {
                const respose = await marcasService.saveMarca({ ...datos, idProveedor: proveedor.id });
                idMarca = respose.data;
            }

            if(previewRef?.current) {
                const nombreImg = `mar_${idMarca}_${getCurrentTime()}.png`

                const blobImg = await toBlob(previewRef.current);
                const file = new File([blobImg], nombreImg);

                await marcasService.saveImagen({file: file, idMarca: idMarca, nombreImg, extension: "/marcas"})
            }
            
            reload(); 
            modalCRUDService.clear();

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Solicitud exitosa' } });
        } catch (error) {
            console.log(error);
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: "Ya existe una marca con el mismo nombre" } });
        }
    }

    return (
        <FormProvider {...methods}>
            <div className="px-2">
                <Tooltip className="m-0" title="Guardar" aria-label="Guardar" style={{position: "absolute", right: "3.5%"}}>
                    <a onClick={handleSubmit(onClickGuardar, () => {})} className="icon-container-actions d-flex">
                        <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                        <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
                    </a>
                </Tooltip>

                <strong style={{fontSize: "13pt"}}>Datos básicos:</strong>
                
                <div className="container w-100 mx-0 px-0 mt-2">
                    <InputForm
                        inputProps={{ control }}
                        identificador="nombreMarca" 
                        label="Nombre de la Marca"
                        placeholder=""
                        required={true}
                        textUppercase={false}
                        className="px-2 col-6"
                        customError={errors.nombreMarca ? "El campo no puede estar vacío" : null} rules={{ maxLength: 200}}
                        style={errors.nombreMarca ? { marginBottom: 0 } : ''}
                    />

                    <InputForm
                        inputProps={{ control }}
                        identificador="orden" 
                        label="Orden"
                        placeholder=""
                        type="number"
                        required={false}
                        textUppercase={false}
                        className="px-2 col-2"
                    />
                </div>

                <div className="container w-100 mx-0 px-0 mt-3">
                    <strong style={{fontSize: "13pt"}}>Imagen de la marca:</strong>
                    <div className="px-3 mt-1">
                        <ImagePickerCrop urlImagen={urlImagen} previewRef={previewRef}/>
                    </div>
                </div>
            </div>
        </FormProvider>
    )
}

export default FormCRUDMarcas;